// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e97c8f3","455":"41db8de4","644":"12178962"}[chunkId] + ".chunk.js";
};